import { createAxios } from "./axiosHttp";

function getDashboard(date) {
  const axios = createAxios();
  let urlPath = `ttmm/dashboard`;
  if (date) {
    urlPath += `?date=${date}`;
  }
  return axios.get(urlPath);
}

export const dashboardService = {
  getDashboard,
};
